//D:\ApplicationDevelopmentHillyardGit\Net\CDN\CDN\app\ext-modules\userMenu\userMenuModule.js
(function () {
    "use strict";

    angular.module("userMenuModule", ['sharedModule']);
})();